import { Progress } from '@atoms/Progress'
import clsx from 'clsx'

type ProgressBarProps = {
  progress: number,
  useTrafficLightColors?: boolean,
}

export function ProgressBar({ progress, useTrafficLightColors = false }: ProgressBarProps) {
  let progressColor: string = 'tw:bg-gray-blue-100'

  if (useTrafficLightColors) {
    if (progress > 0 && progress <= 49) {
      progressColor = 'tw:bg-red-600'
    } else if (progress > 49 && progress <= 80) {
      progressColor = 'tw:bg-yellow-500'
    } else if (progress > 80 && progress < 100) {
      progressColor = 'tw:bg-green-600'
    } else if (progress === 100) {
      progressColor = 'tw:bg-primary-500'
    }
  } else {
    if (progress > 0) {
      progressColor = 'tw:bg-green-600'
    }
  }

  return (
    <Progress 
      value={progress} 
      progressColor={progressColor}
      className={clsx("tw:w-full tw:bg-gray-blue-100")}
      data-testid={`progress-bar-percentage-${progress.toFixed(2)}`}
    />
  )
}
